export default __webpack_public_path__ + "static/media/building_office_icon_RGB.7f16a4df.svg";